/**
 * 异步获取用户关注或粉丝列表。
 *
 * @param user_id - 用户的唯一标识符。
 * @param type - 列表类型，'follow' 表示关注列表，'fans' 表示粉丝列表。
 * @param last_id - 上一次获取列表的最后一项的唯一标识符，用于分页获取更多数据。
 * @returns 包含用户关注或粉丝列表项的 Promise。
 */
export async function fetchUserFollowList(
  user_id: number,
  type: 'follow' | 'fans',
  last_id = 0
): Promise<User.FollowListItem[]> {
  return http
    .get<{
      list: User.FollowListItem[]
    }>('/v1/follow/list', {
      user_id,
      type,
      last_id
    })
    .then((res) => res.data.list)
    .catch(() => [] as User.FollowListItem[])
}
